// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General layout */
html, body {
    height: 100vh; /* Ensure full height for the body */
    margin: 0; /* Remove default margin */
    /* overflow: hidden;  Prevent scrolling */
}

.registration-container {
    display: flex;
    justify-content: space-around; /* Center content */
    align-items: center;
    /* height: 100vh;  */
    background-color: #f8f8f8;
    padding: 20px;
}

.registration-left {
    flex: 0 0 40%; /* Set width to 40% */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    
}

.polymatch-image {
    max-width: 100%; /* Make image responsive */
    height: auto; /* Maintain aspect ratio */
    margin-bottom: 20px;
}

h1 {
    font-size: 2.5rem; /* Responsive font size */
    font-family: 'Baumans', cursive; /* Use Google Fonts for Baumans if not installed */
    font-weight: bold;
    color: rgb(139, 1, 148); /* Purple color */
    margin-bottom: 10px;
}

.registration-right {
    flex: 0 0 40%; /* Set width to 40% */
    max-width: 500px; /* Limit max width */
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 30px;
    border-radius: 8px;
}

form {
    display: flex;
    flex-direction: column;
}

h2 {
    font-size: 1.2rem; /* Responsive font size */
    color: #333;
    margin-bottom: 15px;
}

PReg {
    font-size: 0.9rem; /* Responsive font size */
    color: #666;
    margin-bottom: 20px;
}

input, select {
    width: 100%; /* Full width inputs */
    padding: 5px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem; /* Responsive font size */
}

.file-upload {
    margin-bottom: 20px;
}

.file-upload input {
    display: none;
}

.file-upload label {
    display: block;
    cursor: pointer;
    padding: 10px;
    background-color: #f9f9f9;
    border: 2px dashed #bbb;
    color: #666;
    text-align: center;
    font-size: 0.9rem;
}

.file-upload:hover label {
    background-color: #e6e6e6;
}

/* Purple register button */
.register-button {
    width: 100%; /* Full width button */
    padding: 14px;
    background-color: #702daa; /* Purple color */
    color: #fff;
    font-size: 1.1rem; /* Responsive font size */
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 46px;
}

.register-button:hover {
    background-color: #553785; /* Darker purple on hover */
}

/* Media Queries for Responsiveness */
@media (max-width: 768px) {
    .registration-container {
        flex-direction: column; /* Stack vertically on smaller screens */
        height: auto; /* Allow container to grow with content */
    }
    .registration-left,
    .registration-right {
        flex: 1 1 auto; /* Allow elements to take full width */
        max-width: 100%; /* Prevent overflow */
    }
}
.image-preview {
    margin-bottom: 20px;
    text-align: center;
}

.preview-image {
    max-width: 200px;
    max-height: 200px;
    border-radius: 8px;
    object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/PromotionalPages/PolymatchReg.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa,EAAE,oCAAoC;IACnD,SAAS,EAAE,0BAA0B;IACrC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,6BAA6B,EAAE,mBAAmB;IAClD,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa,EAAE,qBAAqB;IACpC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,eAAe,EAAE,0BAA0B;IAC3C,YAAY,EAAE,0BAA0B;IACxC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB,EAAE,yBAAyB;IAC5C,+BAA+B,EAAE,kDAAkD;IACnF,iBAAiB;IACjB,uBAAuB,EAAE,iBAAiB;IAC1C,mBAAmB;AACvB;;AAEA;IACI,aAAa,EAAE,qBAAqB;IACpC,gBAAgB,EAAE,oBAAoB;IACtC,sBAAsB;IACtB,wCAAwC;IACxC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB,EAAE,yBAAyB;IAC5C,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB,EAAE,yBAAyB;IAC5C,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW,EAAE,sBAAsB;IACnC,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe,EAAE,yBAAyB;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,WAAW,EAAE,sBAAsB;IACnC,aAAa;IACb,yBAAyB,EAAE,iBAAiB;IAC5C,WAAW;IACX,iBAAiB,EAAE,yBAAyB;IAC5C,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB,EAAE,2BAA2B;AAC1D;;AAEA,qCAAqC;AACrC;IACI;QACI,sBAAsB,EAAE,wCAAwC;QAChE,YAAY,EAAE,yCAAyC;IAC3D;IACA;;QAEI,cAAc,EAAE,sCAAsC;QACtD,eAAe,EAAE,qBAAqB;IAC1C;AACJ;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":["/* General layout */\nhtml, body {\n    height: 100vh; /* Ensure full height for the body */\n    margin: 0; /* Remove default margin */\n    /* overflow: hidden;  Prevent scrolling */\n}\n\n.registration-container {\n    display: flex;\n    justify-content: space-around; /* Center content */\n    align-items: center;\n    /* height: 100vh;  */\n    background-color: #f8f8f8;\n    padding: 20px;\n}\n\n.registration-left {\n    flex: 0 0 40%; /* Set width to 40% */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    \n}\n\n.polymatch-image {\n    max-width: 100%; /* Make image responsive */\n    height: auto; /* Maintain aspect ratio */\n    margin-bottom: 20px;\n}\n\nh1 {\n    font-size: 2.5rem; /* Responsive font size */\n    font-family: 'Baumans', cursive; /* Use Google Fonts for Baumans if not installed */\n    font-weight: bold;\n    color: rgb(139, 1, 148); /* Purple color */\n    margin-bottom: 10px;\n}\n\n.registration-right {\n    flex: 0 0 40%; /* Set width to 40% */\n    max-width: 500px; /* Limit max width */\n    background-color: #fff;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    padding: 30px;\n    border-radius: 8px;\n}\n\nform {\n    display: flex;\n    flex-direction: column;\n}\n\nh2 {\n    font-size: 1.2rem; /* Responsive font size */\n    color: #333;\n    margin-bottom: 15px;\n}\n\nPReg {\n    font-size: 0.9rem; /* Responsive font size */\n    color: #666;\n    margin-bottom: 20px;\n}\n\ninput, select {\n    width: 100%; /* Full width inputs */\n    padding: 5px;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 1rem; /* Responsive font size */\n}\n\n.file-upload {\n    margin-bottom: 20px;\n}\n\n.file-upload input {\n    display: none;\n}\n\n.file-upload label {\n    display: block;\n    cursor: pointer;\n    padding: 10px;\n    background-color: #f9f9f9;\n    border: 2px dashed #bbb;\n    color: #666;\n    text-align: center;\n    font-size: 0.9rem;\n}\n\n.file-upload:hover label {\n    background-color: #e6e6e6;\n}\n\n/* Purple register button */\n.register-button {\n    width: 100%; /* Full width button */\n    padding: 14px;\n    background-color: #702daa; /* Purple color */\n    color: #fff;\n    font-size: 1.1rem; /* Responsive font size */\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 20px;\n    margin-left: 46px;\n}\n\n.register-button:hover {\n    background-color: #553785; /* Darker purple on hover */\n}\n\n/* Media Queries for Responsiveness */\n@media (max-width: 768px) {\n    .registration-container {\n        flex-direction: column; /* Stack vertically on smaller screens */\n        height: auto; /* Allow container to grow with content */\n    }\n    .registration-left,\n    .registration-right {\n        flex: 1 1 auto; /* Allow elements to take full width */\n        max-width: 100%; /* Prevent overflow */\n    }\n}\n.image-preview {\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.preview-image {\n    max-width: 200px;\n    max-height: 200px;\n    border-radius: 8px;\n    object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
